import { matrixClient } from '../../client';
import { Log } from '@fanfanlo';
import { RoomEvent } from 'matrix-js-sdk';
import type { IMeetingState } from '../../../element-call/meetingState.types';
import { roomData } from '../data';
import { MATRIX_EVENT_TYPE_MEETING } from '../../../element-call/meetingEvent.types';

const fileLogger = new Log(false, 'im.client.room.handlers.MeetingHandler');
// fileLogger.pause = true;
// fileLogger.childrenPaused = true;

const INTERESTED_EVENTS = [
  MATRIX_EVENT_TYPE_MEETING,
  // 如有其它会议相关事件类型可补充
];

/**
 * 解析会议事件并更新 roomData.meetingStateMap
 */
function handleMeetingEvent(event: any, room: any) {
  const logger = fileLogger.sub(false, 'handleMeetingEvent');
  // logger.pause = true;
  if (!room) return;
  const roomId = room.roomId;
  const eventType = event.getType?.() || event.type;
  const content = event.getContent?.() || event.content || {};
  logger.log('收到会议事件:', roomId, eventType, content);

  // 会议开始
  if (content.state === 'started') {
    if (!roomData.meetingStateMap[roomId]) {
      roomData.meetingStateMap[roomId] = {
        meetingActive: true,
        meetingId: content.call_id,
        initiator: content.initiator || content.creator || '',
        type: content.type || 'normal',
        startedAt: content.started_at || Date.now(),
        // 可扩展更多字段
      };
    } else {
      const state = roomData.meetingStateMap[roomId];
      state.meetingActive = true;
      state.meetingId = content.call_id;
      state.initiator = content.initiator || content.creator || '';
      state.type = content.type || 'normal';
      state.startedAt = content.started_at || Date.now();
      // 可扩展更多字段
    }
    logger.log('会议开始:', roomData.meetingStateMap[roomId]);
  }
  // 会议结束
  else if (content.state === 'ended') {
    const state = roomData.meetingStateMap[roomId];
    if (!state) return;
    state.meetingActive = false;
    // state.endedAt = content.ended_at || Date.now(); // 如有需要
    logger.log('会议结束:', state);
  }
  // 会议类型变更或其它事件
  else if (content.state === 'type_changed') {
    const state = roomData.meetingStateMap[roomId];
    if (!state) return;
    state.type = content.type || state.type;
    logger.log('会议类型变更:', state);
  }
  // 其它会议事件可扩展
}

export const MeetingHandler = {
  init() {
    matrixClient.clientOnEventDispatcher.addListener(
      RoomEvent.Timeline,
      (event: any, room: any, toStartOfTimeline?: boolean) => {
        if (!room || toStartOfTimeline) return;
        const eventType = event.getType?.() || event.type;
        if (INTERESTED_EVENTS.includes(eventType)) {
          handleMeetingEvent(event, room);
        }
      }
    );
  },
}; 